import { Row, Col, Button } from 'antd';
import React from 'react';
import './PricingInfo.scss';
import { ReactSVG } from 'react-svg';

const PricingInfo = ({ pricing = {}, onClickEdit, onClickDelete }) => {
  return (
    <div className="PricingInfo">
      <Row gutter={16}>
        <Col span={12}>
          <div className="content">
            <h4>{pricing.name}</h4>
            <p>
              Start Date:{' '}
              <b>
                {new Date(pricing?.startDate).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                })}
              </b>
            </p>
            <p>
              End Date:{' '}
              <b>
                {pricing?.endDate
                  ? new Date(pricing.endDate).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                    })
                  : '-'}
              </b>
            </p>
            <p>
              Daily Minimum: <b>{pricing.dailyMinimum ? pricing.dailyMinimum : '-'}</b>
            </p>
            <p>
              Weekly Minimum: <b> {pricing.weeklyMinimum ? pricing.weeklyMinimum : '-'} </b>
            </p>
            {pricing?.pricingRanges &&
              Object.keys(pricing.pricingRanges).map((orderType) => (
                <div key={orderType}>
                  <h5>{orderType}</h5>
                  {pricing.pricingRanges[orderType].map((range, index) => (
                    <p key={index}>
                      {range.minOrders} &nbsp; &#8594; &nbsp; {range.maxOrders ? range.maxOrders : '...'} &nbsp;{' '}
                      {range.price} €{' '}
                    </p>
                  ))}
                </div>
              ))}
          </div>
        </Col>
        <Col span={12}>
          <div className="right">
            <span className={'status companies ' + status.toLowerCase()}>{status}</span>
            <div className="actions">
              <Button type="link" className="edit" onClick={onClickEdit}>
                <ReactSVG className="icon" src="/icons/edit.svg" />
              </Button>
              <Button type="link" className="delete" onClick={onClickDelete}>
                <ReactSVG className="icon" src="/icons/delete.svg" />
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default PricingInfo;
